import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { IconButton as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as LeftArrow } from '../../images/icons/arrow-left.svg';

interface IProps extends StyledComponentProps {
    onClick: () => any;
    disabled?: boolean;
}

const PrevButton = (props: IProps) => {
    return (<MuiButton
        disabled={props.disabled}
        className={props.classes.iconButtonRootSvgSecondary}
        onClick={props.onClick}>
        <LeftArrow className={props.classes.iconButtonSvgSecondary}/>
    </MuiButton>)
}
export default withStyles(styles)(PrevButton)